import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  IconButton,
  Box,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PhoneIcon from '@mui/icons-material/Phone';
import { Field, Formik } from 'formik';
import Button from '@mui/material/Button';
import { environment } from '../../../environments/environment';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import Loading from 'react-fullscreen-loading';
import {
  auth,
  firestore,
  recaptchaVerifier,
  _customApp,
} from '../../../../../../libs/firebase-service/src';
import CustomPhoneNumber from '../PhoneNumber/PhoneInput';
import { useNavigate } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from 'react-redux';
import { setUser } from '../../../../../../libs/redux-slices/src';
import { useDispatch } from 'react-redux';
import ReactCodeInput from 'react-code-input';
import { useTranslation } from 'react-i18next';
import PhoneInternational from '../PhoneNumber/phoneinternational';

const useStyles = makeStyles({
  input: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
});
const PhoneNumberForm = ({
  onClose,
  open,
  user,
  phoneNumber,
  setPhoneNumber,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [expandForm, setExpandForm] = useState(false);
  const [OTP, setOTP] = useState('');
  const [verifiedNum, setVerifiedNum] = useState(false);
  const [err, setErr] = useState('');
  const [error, setError] = useState('');
  const classes = useStyles();
  const userData = useSelector((state) => state.authReducer.userData);
  const dispatch = useDispatch();

  let phoneNumbert = phoneNumber;
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const authUser = await auth.currentUser;
      const doc = await firestore.collection('users').doc(authUser?.uid);
      await firestore
        .collection('users')
        .doc(doc.id)
        .set(
          {
            phoneNumber: phoneNumbert,
          },
          { merge: true }
        )
        .then(async () => {
          await getUser();
          setErr('');
          const updatedUser = { ...userData, phoneNumber: phoneNumbert };
          dispatch(setUser({ userData: updatedUser }));
        });
    } catch (e) {
      console.log('erorr', e.message);
      setErr(e.message);
      setLoading(false);
    }
  };

  const getUser = async () => {
    // setIsFirst(true)
    handleSubmit();
  };

  const requestOTP = async (e) => {
    setError('');
    if (phoneNumbert.length < 12) {
      setError(t('profilee.pleaseEnterValidphoneNumber')); //t("profilee.pleaseEnterValidphoneNumber")

      e.preventDefault();
    } else {
      const { docs } = await firestore
        .collection('users')
        .where('phoneNumber', '==', phoneNumbert)
        .get();
      if (docs.length > 0) {
        setError(t('profilee.thisNumberAlreadyUsed'));
      } else {
        setErr('');
        e.preventDefault();
        const currentUser = auth?.currentUser;

        // Guard: if there is no authenticated Firebase user, we cannot link a phone number.
        // This avoids "Cannot read properties of null (reading 'linkWithPhoneNumber')" and
        // tells the user to re-authenticate instead of crashing.
        if (!currentUser) {
          setError(
            
              'Your session has expired. Please sign in again to change your phone number.'
          );
          return;
        }

        // We have a logged-in user and a free phone number → show OTP section
        setExpandForm(true);
        geterate();

        if (user?.phoneNumber !== null) {
          let hasPhoneProvider = false;
          currentUser.providerData.map((provider) => {
            if (provider?.providerId === 'phone') {
              hasPhoneProvider = true;
            }
          });
          if (hasPhoneProvider)
            await currentUser
              .unlink('phone')
              .then(() => {})
              .catch((error) => {
                setLoading(false);
                console.log(error, 'error provider');
              });
        }

        let appvarifier = window.recaptchaVerifier;
        if (!appvarifier) {
          setError(
            t('profilee.somethingWentWrong') ||
              'Something went wrong while preparing verification. Please reload the page and try again.'
          );
          return;
        }

        await currentUser
          .linkWithPhoneNumber(phoneNumbert, appvarifier)
          .then((confirmationResult, result) => {
            window.confirmationResult = confirmationResult;
            setErr('');
          })
          .catch((error) => {
            setErr(t('profilee.pleaseReloadPageToVerfiyAgain'));
          });
      }
    }
  };
  const verifyOTP = (e) => {
    let otp = e.target.value;
    setOTP(otp);
    if (OTP?.length === 6) {
      setLoading(true);
      let confirmationResult = window.confirmationResult;
      confirmationResult
        .confirm(OTP)
        .then(async (result) => {
          setLoading(true);
          const authUser = auth?.currentUser;
          if (!authUser) {
            setLoading(false);
            setErr(
              t('profilee.sessionExpiredPleaseLoginAgain') ||
                'Your session has expired. Please sign in again to complete phone verification.'
            );
            return;
          }
          const doc = await firestore.collection('users').doc(authUser?.uid);
          await firestore
            .collection('users')
            .doc(authUser?.uid)
            .set(
              {
                phoneNumber: phoneNumbert,
              },
              { merge: true }
            )
            .then(async () => {
              setErr('');
              const updatedUser = { ...userData, phoneNumber: phoneNumbert };
              dispatch(setUser({ userData: updatedUser }));
              setExpandForm(false);
            });
          // window.location.reload()
          // User signed in successfully.
          navigate(`/profile`);
          setErr('');
          // setVerifiedNum(true);
          onClose();
          setLoading(false);
          setPhoneNumber('');
        })
        .catch((e) => {
          setLoading(false);
          console.warn(e.message);
          let notCorrect =
            'The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.';
          e.message === notCorrect
            ? setErr(t('profilee.notCorrectPleaseVerfiyYourNumberAgain'))
            : setErr(e.message);
        })
        .catch((err) => {
          setLoading(false);
          setErr(t('profilee.somethingWentWrong'));
        });
    } else setErr(t('profilee.pleaseEnter6Numbers'));
  };

  const geterate = () => {
    window.recaptchaVerifier = new recaptchaVerifier(
      'recaptcha-container',
      {
        size: 'invisible',
        callback: (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          // ...
        },
        'expired-callback': () => {
          // Response expired. Ask user to solve reCAPTCHA again.
          // ...
        },
      },
      _customApp
    );
  };
  const [t, i18n] = useTranslation();

  const resetForm = () => {
    setPhoneNumber(''); // Clear the phone number field
    setOTP(''); // Clear the OTP field
    setError(''); // Clear the error message
    setErr(''); // Clear any other error messages
    setExpandForm(false); // Close the expanded form
  };

  // Add an effect to reset the form when the dialog is closed
  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={() => {
        resetForm();
        onClose();
      }}
      aria-labelledby="change-phone-dialog"
      dir={i18n.language === 'ar' || i18n.language === 'he' ? 'rtl' : 'ltr'}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      {/* Header with icon and close button */}
      <DialogTitle sx={{ p: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: 3,
            pb: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '12px',
                background: `linear-gradient(135deg, ${environment.mainColor}20, ${environment.mainColor}10)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <PhoneIcon
                sx={{
                  color: environment.mainColor,
                  fontSize: 24,
                }}
              />
            </Box>
            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  fontSize: '20px',
                  color: '#172B4D',
                  fontFamily: 'Jost, sans-serif',
                }}
              >
                {t('profilee.changePhone')}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: '#6B7280',
                  fontSize: '14px',
                  fontFamily: 'Jost, sans-serif',
                }}
              >
                Update your phone number
              </Typography>
            </Box>
          </Box>
          <IconButton
            onClick={() => {
              resetForm();
              onClose();
            }}
            sx={{
              color: '#6B7280',
              '&:hover': {
                backgroundColor: '#F3F4F6',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Formik
          initialValues={{
            fullName: '',
            phoneNumber: '',
            email: '',
          }}
          // validationSchema={validateSchema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            touched,
            handleSubmit,
            values,
            handleChange,
            handleBlur,
          }) => (
            <div>
              <Grid spacing={3} container>
                <Grid
                  item
                  justify="space-around"
                  container
                  xs={12}
                  spacing={2}
                  sx={{
                    marginTop: '8px',
                  }}
                >
                  <Grid item xs={12}>
                    <form>
                      <div style={{ marginBottom: '20px' }}>
                        <Typography
                          variant="body2"
                          sx={{
                            marginBottom: '8px',
                            fontWeight: '500',
                            color: '#666',
                            fontSize: '14px',
                          }}
                        >
                          {t('profilee.verifyPhoneNumber')}
                        </Typography>
                        <PhoneInternational
                          phoneNumber={phoneNumber}
                          setPhoneNumber={setPhoneNumber}
                          backgroundColor="white"
                          onlyUS
                        />
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginBottom: '16px',
                        }}
                      >
                        <Button
                          size="medium"
                          onClick={requestOTP}
                          variant="contained"
                          sx={{
                            backgroundColor: environment.mainColor,
                            color: 'white',
                            padding: '10px 32px',
                            borderRadius: '25px',
                            fontWeight: '500',
                            fontSize: '14px',
                            textTransform: 'none',
                            minWidth: '180px',
                            boxShadow: `0 2px 8px ${environment.mainColor}30`,
                            '&:hover': {
                              backgroundColor: environment.mainColor,
                              filter: 'brightness(0.95)',
                              boxShadow: `0 4px 12px ${environment.mainColor}40`,
                              transform: 'translateY(-1px)',
                            },
                            '&:active': {
                              transform: 'translateY(0px)',
                            },
                          }}
                        >
                          {t('profilee.verifyPhoneNumber')}
                        </Button>
                      </div>

                      {expandForm === true ? (
                        <div
                          style={{
                            marginTop: '20px',
                            padding: '24px',
                            backgroundColor: '#fafafa',
                            borderRadius: '16px',
                            border: `1px solid ${environment.mainColor}20`,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              marginBottom: '16px',
                              fontWeight: '500',
                              color: '#666',
                              textAlign: 'center',
                              fontSize: '14px',
                            }}
                          >
                            Enter verification code
                          </Typography>

                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginBottom: '20px',
                            }}
                          >
                            <ReactCodeInput
                              type="text"
                              onChange={(pinCode) => {
                                setOTP(pinCode);
                              }}
                              fields={6}
                              inputStyle={{
                                fontFamily:
                                  'system-ui, -apple-system, sans-serif',
                                fontSize: '16px',
                                fontWeight: '600',
                                width: '40px',
                                height: '48px',
                                borderRadius: '8px',
                                border: `1px solid ${environment.mainColor}30`,
                                textAlign: 'center',
                                margin: '0 3px',
                                backgroundColor: 'white',
                                outline: 'none',
                                transition: 'all 0.2s ease',
                                color: environment.mainColor,
                              }}
                              inputStyleInvalid={{
                                border: '2px solid #ff4444',
                              }}
                            />
                          </div>

                          {err && (
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#d32f2f',
                                textAlign: 'center',
                                marginBottom: '16px',
                                padding: '8px 12px',
                                backgroundColor: '#ffebee',
                                borderRadius: '8px',
                                fontSize: '13px',
                                border: '1px solid #ffcdd2',
                              }}
                            >
                              {err}
                            </Typography>
                          )}

                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                            }}
                          >
                            <Button
                              size="medium"
                              onClick={verifyOTP}
                              variant="contained"
                              sx={{
                                backgroundColor: environment.mainColor,
                                color: 'white',
                                padding: '10px 32px',
                                borderRadius: '25px',
                                fontWeight: '500',
                                fontSize: '14px',
                                textTransform: 'none',
                                minWidth: '140px',
                                boxShadow: `0 2px 8px ${environment.mainColor}30`,
                                '&:hover': {
                                  backgroundColor: environment.mainColor,
                                  filter: 'brightness(0.95)',
                                  boxShadow: `0 4px 12px ${environment.mainColor}40`,
                                  transform: 'translateY(-1px)',
                                },
                                '&:active': {
                                  transform: 'translateY(0px)',
                                },
                              }}
                            >
                              {t('profilee.save')}
                            </Button>
                          </div>
                        </div>
                      ) : null}

                      {error && (
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#d32f2f',
                            textAlign: 'center',
                            marginTop: '12px',
                            padding: '8px 16px',
                            backgroundColor: '#ffebee',
                            borderRadius: '8px',
                            fontSize: '13px',
                            border: '1px solid #ffcdd2',
                          }}
                        >
                          {error}
                        </Typography>
                      )}

                      <div id="recaptcha-container"></div>
                    </form>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          )}
        </Formik>
      </DialogContent>
      <Loading
        loading={!!loading}
        background="rgba(86, 100, 210, 0.1)"
        loaderColor={environment.mainColor}
      />
    </Dialog>
  );
};

export default PhoneNumberForm;
